// removed by extract-text-webpack-plugin
module.exports = {"mainContent":"ORc6N-v1tDo-IXMq5e2XO"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/style/globalStyle.scss
// module id = 39
// module chunks = 0